import { render } from "./o2-saturation.vue?vue&type=template&id=5c37e7e7&scoped=true"
import script from "./o2-saturation.vue?vue&type=script&lang=js"
export * from "./o2-saturation.vue?vue&type=script&lang=js"

import "./o2-saturation.vue?vue&type=style&index=0&id=5c37e7e7&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/lify-blends-recommender/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c37e7e7"]])

export default __exports__